export default "__VITE_ASSET__CwCBzckZ__"